import { Injectable } from '@angular/core';
import { DetailService } from '../api/detail.api.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { DetailModel } from '../../models/detail.model';
import { List } from 'immutable';
import { BaseDataStore } from './base-data.store';
import { UserService } from '../user.service';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class DetailStore extends BaseDataStore {
  private _details: BehaviorSubject<List<DetailModel>> = new BehaviorSubject(List<DetailModel>([]));

  constructor(
    private detailService: DetailService,
    private userService: UserService,
  ) {
    super();
    this.behaviorSubjectList.push(this._details);
  }

  get $details(): Observable<List<DetailModel>> {
    // Only load data when has at leaset one subscriber
    //if (!this.dataLoaded && this.userService.isUserLoggedIn) {
    if (this.userService.isUserLoggedIn) {
      //this.dataLoaded = true;
      this.loadInitialData();
    }
    return this._details.asObservable();
  }

  get $firstDetail(): Observable<DetailModel | null> {
    return this.$details.pipe(
      map((details: List<DetailModel>) => {
        if (details && details.count() > 0) {
          const detail = details.get(0);
          return detail;
        }

        return null;
      }),
    );
  }

  public loadInitialData(): void {
    this.detailService.getDetails().subscribe(
      (res: any) => {
        // console.log(res);
        const details = (<Object[]>res).map((detail: any) => new DetailModel(detail));
        this._details.next(List(details));
      },
      (err: any) => console.log('Error retrieving Details'),
    );
  }

  public $addDetail(newDetail: DetailModel): Observable<any> {
    // Make web api call to add detail
    const obs = this.detailService.saveDetail(newDetail);

    obs.subscribe((res: any) => {
      this._details.next(this._details.getValue().push(new DetailModel(res)));
    });

    return obs;
  }
}
